// @link https://en.wikipedia.org/wiki/Luhn_algorithm

// Copy-pasted-and-adapted from this gist:
// @link https://gist.github.com/ShirtlessKirk/2134376
export const checkLuhn: (target: string) => boolean = (function (array) {
  return function luhn(number: string) {
    if (!number) {
      return false;
    }
    number = number.replace(/-/g, "");
    let length = number.length;
    let bit = 1;
    let sum = 0;
    let value;

    while (length) {
      value = parseInt(number.charAt(--length), 10);
      bit ^= 1;
      sum += bit ? array[value] : value;
    }

    return sum % 10 === 0;
  };
})([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);
